import { AppointmentID } from "./Appointment";
import { DealerLocationID } from "./DealerLocation";
import { LANGUAGE_CODES } from "./Language";
import { UserID } from "./User";

export type AITranslationID = number;

export interface AITranslation {
  created_on: string;
  updated_on: string;
  id: AITranslationID;
  model: string;
  original_language_code: LANGUAGE_CODES;
  original_value_1: string;
  original_value_2: string;
  original_value_3: string;
  translated_language_code: LANGUAGE_CODES;
  translated_value_1: string;
  translated_value_2: string;
  translated_value_3: string;
  user_id: UserID;
  appointment_id: AppointmentID | null;
  dealer_location_id: DealerLocationID;
}
